export let locale = localStorage.getItem("language");